export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'youhuiquan',
    name: '优惠券',
    icon: 'ri-coupon-line',
    description: '汇集各大电商平台、品牌商家的最新优惠券信息，购物更省钱',
    articleCount: 48,
    color: 'accent',
  },
  {
    slug: 'huiyuanyiquan',
    name: '会员权益',
    icon: 'ri-vip-crown-line',
    description: '整合各大平台会员专属福利与权益，让你的会员身份价值最大化',
    articleCount: 36,
    color: 'primary',
  },
  {
    slug: 'shenghuobutie',
    name: '生活补贴',
    icon: 'ri-money-dollar-circle-line',
    description: '政府补贴、企业津贴、生活保障金等实用补贴信息一网打尽',
    articleCount: 29,
    color: 'secondary',
  },
  {
    slug: 'zhichangfuli',
    name: '职场福利',
    icon: 'ri-briefcase-line',
    description: '职场人专属福利指南，涵盖五险一金、年假、培训补贴等',
    articleCount: 34,
    color: 'accent',
  },
  {
    slug: 'jiuyuefuli',
    name: '教育福利',
    icon: 'ri-book-open-line',
    description: '学生助学贷款、奖学金、教育补贴及免费学习资源汇总',
    articleCount: 22,
    color: 'primary',
  },
  {
    slug: 'jiankangfuli',
    name: '健康福利',
    icon: 'ri-heart-pulse-line',
    description: '体检优惠、疫苗接种、健康保险等医疗健康类福利资源',
    articleCount: 27,
    color: 'secondary',
  },
  {
    slug: 'lvyoufuli',
    name: '旅游福利',
    icon: 'ri-flight-takeoff-line',
    description: '景区门票减免、酒店特惠、出行补贴等旅游相关福利',
    articleCount: 19,
    color: 'accent',
  },
  {
    slug: 'jinrongfuli',
    name: '金融福利',
    icon: 'ri-bank-line',
    description: '信用卡权益、贷款利率优惠、理财福利等金融服务类资源',
    articleCount: 31,
    color: 'primary',
  },
];